import { Star } from "lucide-react";

export default function Stars({ rating = 5, size = 14, className = "", testId }) {
  return (
    <span className={`stars ${className}`} aria-label={`${rating} out of 5 stars`} data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          strokeWidth={1.4}
          className={n <= rating ? "stars__on" : "stars__off"}
          fill={n <= rating ? "currentColor" : "none"}
        />
      ))}
    </span>
  );
}
